import { useEffect, useRef } from "react";
import Hook from "./useDropdown";
import "./index.scss";

function ManagePlanDropdown({ isCancellationPending }) {
  const {
    BLOCK,
    isOpen,
    toggle,
    close,
    onChangeSubscription,
    onCancelSubscription,
    onReactivate,
    translate,
  } = Hook.useDropdown({ isCancellationPending });

  const dropdownRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        close();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, close]);

  return (
    <div className={BLOCK.current} ref={dropdownRef}>
      <button
        className={`${BLOCK.current}__trigger`}
        onClick={toggle}
        type="button"
        disabled={isCancellationPending}
      >
        {translate("managePlan")}
      </button>
      {isOpen && (
        <ul className={`${BLOCK.current}__menu`}>
          <li>
            <button
              type="button"
              onClick={isCancellationPending ? onReactivate : onChangeSubscription}
            >
              {isCancellationPending
                ? translate("reactivate")
                : translate("changeSubscription")}
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={onCancelSubscription}
              disabled={isCancellationPending}
            >
              {translate("cancelSubscription")}
            </button>
          </li>
        </ul>
      )}
    </div>
  );
}

export default ManagePlanDropdown;
